module.exports = __webpack_public_path__ + "img/round 拷贝@2x.29bf0ea9.png";